import { render, staticRenderFns } from "./WidgetTutorial.vue?vue&type=template&id=d61b03a4&scoped=true"
import script from "./WidgetTutorial.vue?vue&type=script&lang=js"
export * from "./WidgetTutorial.vue?vue&type=script&lang=js"
import style0 from "./WidgetTutorial.vue?vue&type=style&index=0&id=d61b03a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61b03a4",
  null
  
)

export default component.exports